export class OpenFinanceFactory {
  constructor(instance) {
    this.instance = instance;
  }

  /** Fora do gate: é o que decide entre mostrar a vitrine e o módulo. */
  getStatus() {
    return this.instance.get('/v1/open-finance/status');
  }

  /** itemId presente = reconexão de um banco que quebrou (LOGIN_ERROR). */
  createConnectToken(itemId) {
    return this.instance.post('/v1/open-finance/connect-token', {
      itemId: itemId || undefined,
    });
  }

  createItem(itemId) {
    return this.instance.post('/v1/open-finance/items', { itemId });
  }

  getItems() {
    return this.instance.get('/v1/open-finance/items');
  }

  syncItem(id) {
    return this.instance.post(
      `/v1/open-finance/items/${encodeURIComponent(id)}/sync`,
    );
  }

  disconnectItem(id) {
    return this.instance.delete(
      `/v1/open-finance/items/${encodeURIComponent(id)}`,
    );
  }

  getAccounts() {
    return this.instance.get('/v1/open-finance/accounts');
  }

  linkAccount(id, gloFluxoId) {
    return this.instance.patch(
      `/v1/open-finance/accounts/${encodeURIComponent(id)}`,
      {
        gloFluxoId,
      },
    );
  }

  getTransactions(filter) {
    return this.instance.get('/v1/open-finance/transactions', {
      params: filter || null,
    });
  }

  /** Uma movimentação com banco e conta, para a tela que abre só com o id. */
  getTransaction(id) {
    return this.instance.get(
      `/v1/open-finance/transactions/${encodeURIComponent(id)}`,
    );
  }

  getCategorias() {
    return this.instance.get('/v1/open-finance/categorias');
  }

  importTransaction(id, data) {
    return this.instance.post(
      `/v1/open-finance/transactions/${encodeURIComponent(id)}/importar`,
      data,
    );
  }

  vincularTransaction(id, gloFinanceiroId) {
    return this.instance.post(
      `/v1/open-finance/transactions/${encodeURIComponent(id)}/vincular`,
      {
        gloFinanceiroId,
      },
    );
  }

  conferirTransaction(id, conferido) {
    return this.instance.patch(
      `/v1/open-finance/transactions/${encodeURIComponent(id)}/conferido`,
      { conferido },
    );
  }

  /** Uma chamada para a seleção inteira do extrato. */
  conferirTransactionsEmLote(ids, conferido) {
    return this.instance.patch('/v1/open-finance/transactions/conferido', {
      ids,
      conferido,
    });
  }
}

export default (instance) => new OpenFinanceFactory(instance);
